import PreviewModal from './previewModal';

export default PreviewModal;